import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {LOAD_SVG_RESOURCES} from "../../../common/it-svg-util";

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit {

  @Input() firstPageTitle: string;
  @Input() pageTitle: string;
  @Input() parentStartDate: Date;
  @Input() parentEndDate: Date;
  @Input() displayTopbar: boolean;
  @Input() lastPageTitle: string;

  @Output() setStartDate = new EventEmitter<Date>();
  @Output() setEndDate = new EventEmitter<Date>();
  @Output() onClickExport = new EventEmitter<string>();

  todaysDate: Date = new Date();

  topBarLeftArrowIconUrl: string = LOAD_SVG_RESOURCES.topBarLeftArrowIcon;

  constructor() {}

  ngOnInit() {
  }

  handleExportClick() {
    this.onClickExport.emit();
  }

  onStartDateSelect(e: Date) {
    this.setStartDate.emit(e);
  }

  onEndDateSelect(e: Date) {
    this.setEndDate.emit(e);
  }

}
